import { ajaxFunc } from '../tools';

const commonMember = {
  //优惠券
  //支付完dingdan
  getCouponNameByOrderId: ajaxFunc('/commonMember/getCouponNameByOrderId', 'post')

};

export default commonMember;



// WEBPACK FOOTER //
// ./src/request/api/commonMember.js